<table [attr.aria-label]="popoverHeaders.join(' - ')">
  <thead
    class="popover-table"
    [ngClass]="{ 'popover-table-domain-performance': popoverTableData.isViewReportLink }"
  >
    <tr>
      <th
        scope="col"
        class="name-column"
        [ngClass]="
          popoverTableData.isViewReportLink ? 'name-column-domain-performance' : 'name-column-student-growth'
        "
      >
        {{ popoverHeaders[0] }}
        <savvas-shared-ui-static-text
          [ngClass]="getStaticLableClass()"
          class="static-label-popover-text"
          *ngIf="popoverTableData.isStaticUiTextForHeader"
          [text]="popoverTableData.staticUiTextForPlacementLevel"
          data-size="small"
          [color]="popoverTableData.staticColorText"
        ></savvas-shared-ui-static-text>
      </th>
      <th
        scope="col"
        class="score-column"
        [ngClass]="
          popoverTableData.isViewReportLink ? 'score-column-domain-performance' : 'score-column-student-growth'
        "
      >
        {{ popoverHeaders[1] }}
      </th>
      <th scope="col" class="view-report-column" *ngIf="popoverTableData.isViewReportLink"></th>
    </tr>
  </thead>
  <tbody
    class="student-table"
    [ngClass]="{ 'student-table-domain-performance': popoverTableData.isViewReportLink }"
  >
    <ng-container *ngFor="let student of students">
      <tr
        [ngClass]="{
          'row-student-growth': !popoverTableData.isViewReportLink
        }"
      >
        <td
          class="name-column"
          [ngClass]="
            popoverTableData.isViewReportLink ? 'name-column-domain-performance' : 'name-column-student-growth'
          "
          [title]="student.studentName"
        >
          {{ student.studentName }}
        </td>
        <td
          class="score-column"
          [ngClass]="
            popoverTableData.isViewReportLink ? 'score-column-domain-performance' : 'score-column-student-growth'
          "
        >
          {{ student.score }}
        </td>
        <td class="view-report-column" *ngIf="popoverTableData.isViewReportLink">
          <growth-report-cel-text-link
            class="view-report-link"
            [label]="'popover-table.view-report' | translate"
            [disabled]="false"
            (celTextLinkClicked)="navigateToStudentReport(student.studentId)"
          ></growth-report-cel-text-link>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
